



























































import axios from 'axios';
import ActionCellRenderer from '@/components/ag-grid/ActionCellRenderer.vue'
import Vue from 'vue';

export default Vue.extend({
    components: {
        
    },
    data() {
        return {
            isSaving: false,
            isRemoving: false,
            isShowConfirmRemoveModal: false,
            isShowWorkTypeModal: false,
            settings: {
                work_types: [] as any[]
            } as any ,
            gridOptions: {
                columnDefs: [] as any[],
                rowHeight: 35
            } as any,
            worktype: {
                id: 0,
                name: '',
                description: ''
            },
            columnDefs: [
                {
                    headerName: 'Name',
                    field: 'name',
                    sortable: true,
                    filter: true,
                    editable: true
                },
                {
                    headerName: 'Description',
                    field: 'description',
                    sortable: true,
                    filter: true,
                    editable: true
                }
            ] as any[]
        }
    },
    mounted() {
        this.columnDefs = [
            {
                headerName: 'Actions',
                editable: false,
                colId: 'params',
                field: 'value',
                cellRendererFramework: ActionCellRenderer,
                cellRendererParams: {
                    remove: this.confirmRemoveEntry,
                },
                width: 50
            },
            {
                headerName: 'Name',
                field: 'name',
                sortable: true,
                filter: true,
                editable: true
            },
            {
                headerName: 'Description',
                field: 'description',
                sortable: true,
                filter: true,
                editable: true
            }
        ];

        this.getSettings();
    },
    methods: {
        resetWorkType() {
            this.worktype = {
                id: 0,
                name: '',
                description: ''
            };
        },
        confirmRemoveEntry(data: any) {
            this.worktype = data;

            this.isShowConfirmRemoveModal = true;
        },
        async remove() {
            if (this.isRemoving) { return; }

            this.isRemoving = true;

            try {
                await axios.delete(`/settings/worktypes/${this.worktype.id}`);

                const index = this.settings.work_types.indexOf(this.worktype);
                if (index > -1) {
                    this.settings.work_types.splice(index, 1);
                }

                this.isShowConfirmRemoveModal = false;

                this.resetWorkType();
            } catch (e) {
                console.error(e);
            }

            this.isRemoving = false;
        },
        async onCellChanged(params: any) {
             try {
                await axios.put(`/settings/worktypes/${params.data.id}`, params.data);
            } catch (e) {
                console.error(e);
            }
        },
        onGridReady(params: any) {
            params.api.sizeColumnsToFit(1);
        },
        onRowChanged(params: any) {
            console.log(params)
        },
        async getSettings() {
            try {
                const result = await axios.get(`/settings`);
                this.settings = result.data;
            } catch (e) {
                console.error(e);
            }
        },
        async save() {
            if (this.isSaving) { return; }
            this.isSaving = true;

            try {
                const result = await axios.post(`/settings/worktypes`, this.worktype);
                this.settings.work_types.push(result.data);

                this.resetWorkType();

                this.isShowWorkTypeModal = false;
            } catch (e) {
                console.error(e);
            }

            this.isSaving = false;
        }
    }
});
